import React from 'react';
import { Button } from '../ui/Button';

const IOSRestrictedModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-sm w-full overflow-hidden shadow-lg">
        {/* Header with Close Button */}
        <div className="flex items-center p-4 pt-3 justify-between">
          <h2 className="text-xl font-bold text-text-primary">Manage Subscription</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Close modal"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-x w-4 h-4 md:w-5 md:h-5"
              aria-hidden="true"
            >
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="px-3 pb-4 pt-0">
          {/* <p className="text-gray-700 text-center mb-2">
            iOS in-app purchases are not supported at this time.
          </p> */}
          <p className="text-[#444444] text-sm">
            You can manage your subscription by logging into the desktop view.
          </p>
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-3">
          <Button
            onClick={onClose}
            variant="primary"
            size="lg"
            className="w-full h-10"
          >
            OK
          </Button>
          {/* <Button
            onClick={() => {
              window.open(window.location.href, '_blank');
              onClose();
            }}
            variant="primaryDarkBlue"
            className="flex-1"
          >
            Open in Browser
          </Button> */}
        </div>
      </div>
    </div>
  );
};

export default IOSRestrictedModal;
